import { plexTranslationUploadManager } from "./PlexTranslationUpload.slice";

export const plexTranslationUploadActions = { ...plexTranslationUploadManager.actions };
